export type HomeServicesValues = 0 | 1 | 2 | 3;
export enum HOME_SERVICES_VALUES {
    WEB_QUOTATIONS = 0,
    CURRENT_POLICIES = 1,
    CLAIMS = 2,
    CLAIMS_VS_WALLET = 3,
}